import { ReactNode } from "react"
import { Link } from "../../../models/types/Link.type"

type LinksProps = {
    title: string
    links: Link[]
    children?: ReactNode
}

const FooterLinks = ({ title, links, children }: LinksProps) => {
  return (
    <section className='link-block'>
      <div className='text-container'>
        <h5 className='h5'>{title}</h5>
        <br />
        {links && (
          <ul aria-label={title} className='ul'>
            {links.map((link) => (
              <li key={`link-${link.id}`}>
                <a href={link.url} className='a'>
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        )}
        {children}
      </div>
      <style jsx>{`
        .link-block {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        ul {
          list-style: none;
          padding: 0;
          color: #4a4c49;
        }

        li {
          margin-bottom: 14px;
        }

        .h5 {
          font-weight: bold;
          font-size: 22px;
          line-height: 1.5;
          color: #4a4c49;
          white-space: nowrap;
        }
        .a {
          text-decoration: none;
          font-size: 16px;
          white-space: nowrap;
        }

        @media screen and (max-width: 500px) {
          .link-block {
            align-items: flex-start;
          }
        }
      `}</style>
    </section>
  )
}

export default FooterLinks